import { Button } from "@studyplus/boron-ui";
import TimeHelper from "../../../../helpers/TimeHelper";
import { useFlashMessage } from "../../../../hooks/useFlashMessage";
import { Invitation } from "../../../../interfaces/SectionOperatorsInterface";
import styles from "./styles.scss";
import { useDeleteInvite } from "./useDeleteInvite";

interface Props {
  sectionId: string;
  sectionName: string;
  invitingOperators: Invitation[];
}

const InvitingOperatorList = (props: Props) => {
  if (!props.invitingOperators || props.invitingOperators.length === 0) {
    return null;
  }

  return (
    <div className={styles.root}>
      <div className={styles.label}>招待中スタッフ</div>
      <Table
        invitingOperators={props.invitingOperators}
        sectionId={props.sectionId}
        sectionName={props.sectionName}
      />
    </div>
  );
};

const Table = ({ invitingOperators, sectionId, sectionName }: Props) => {
  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr className={styles.tableHeader}>
            <th>送信日時</th>
            <th>メールアドレス</th>
            <th></th>
          </tr>
        </thead>
        <TableBody
          invitingOperators={invitingOperators}
          sectionId={sectionId}
          sectionName={sectionName}
        />
      </table>
    </div>
  );
};

const TableBody = ({ invitingOperators, sectionId, sectionName }: Props) => {
  return (
    <tbody>
      {invitingOperators.map((invite: Invitation) => (
        <TableRow
          key={`operator-${invite.id}`}
          invite={invite}
          sectionId={sectionId}
          sectionName={sectionName}
        />
      ))}
    </tbody>
  );
};

const TableRow = ({
  invite,
  sectionId,
  sectionName,
}: {
  invite: Invitation;
  sectionId: string;
  sectionName: string;
}) => {
  const { mutate: deleteInvite, isPending } = useDeleteInvite();
  const { showSuccessMessage, showErrorMessage } = useFlashMessage();

  const handleClick = () => {
    if (isPending) {
      return;
    }

    if (
      window.confirm(
        `本当に「${invite.email}」への${sectionName}に対する招待をやめてよろしいですか？`,
      )
    ) {
      deleteInvite(
        { sectionId, inviteId: invite.id },
        {
          onSuccess: () => {
            showSuccessMessage("招待をキャンセルしました");
          },
          onError: () => {
            showErrorMessage("招待をキャンセルできませんでした");
          },
        },
      );
    }
  };

  return (
    <tr key={`operator-${invite.id}`} className={styles.tableRow}>
      <td className={styles.tableCol}>
        {TimeHelper.fullFormat(invite.sentAt)}
      </td>
      <td className={styles.tableCol}>{invite.email}</td>
      <td className={styles.tableLastCol}>
        <Button
          className={styles.btn}
          onClick={handleClick}
          disabled={isPending}
          variant="outline"
        >
          招待をキャンセル
        </Button>
      </td>
    </tr>
  );
};

export default InvitingOperatorList;
